import { GET, POST, PUT } from './core';

export const getEndpointWithPrefix = (endpoint) => {
  return `/printer-settings${endpoint}`;
};

export const getAllPrinterSettings = (token) => {
  return GET(getEndpointWithPrefix(''), token);
};

export const createPrinterSettings = (request, token) => {
  return POST(getEndpointWithPrefix(''), request, token);
};

export const updatePrinterSettings = (taskKey, request, token) => {
  return PUT(getEndpointWithPrefix(`/${taskKey}`), request, token);
};
